import { Injectable } from '@angular/core';
import { Router, CanActivate, Route, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '@core/services/authentication/auth.service';

@Injectable()
export class LoginGuard implements CanActivate {

  readonly permiso: any = {};

  constructor(
    private readonly router: Router,
    private readonly _authService: AuthService,
  ) {
  }

  canLoad(route: Route): boolean {
    if (this._authService.isLoggedIn()) {
      return true;
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }

  canActivate(_route: ActivatedRouteSnapshot): boolean {
    const url = `/${_route}`;
    if (this._authService.isLoggedIn()) {
      return true;
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }
}
